import {DateTime} from "date-time-js";

export class DateUtils {
  static convertDate(date: Date): string {
    return date.getFullYear() +
      '-' + DateUtils.pad(date.getMonth() + 1) +
      '-' + DateUtils.pad(date.getDate()) +
      'T' + DateUtils.pad(date.getHours()) +
      ':' + DateUtils.pad(date.getMinutes()) +
      ':' + DateUtils.pad(date.getSeconds());
  }

  static roundMinutesToHour(minutes: number): number {
    let hours = Math.floor(minutes / 60);
    if(minutes - hours * 60 > 10)
      hours ++;

    return hours;
  }

  private static pad(number: number): string {
    if (number < 10) {
      return '0' + number;
    }
    return number + "";
  }

  static isEqualDates(date1?: Date, date2?: Date): boolean {
    if(date1 == null && date2 == null)
      return true;

    if(date1 == null || date2 == null)
      return false;

    let date1Str = new DateTime(date1).format('yyyy-MM-dd');
    let date2Str = new DateTime(date2).format('yyyy-MM-dd');

    return date1Str == date2Str;
  }

  static formatDate(date: Date): string {
    return new DateTime(date).format('yyyy-MM-dd');
  }
}
